// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-card {\n    user-select: none;\n}\n\n.collapse-section-button {\n    cursor: pointer;\n    margin-right: 8px;\n    padding: 8px;\n    border-radius: 25%;\n}\n\n.collapse-section-button:hover {\n    background: #eeeeee;\n}", ""]);
// Exports
module.exports = exports;
